<template>
    <div class="text-center">
        <spinner class="mx-auto mb-2"/>
        <img :src="$widgetConfig.companyLogo" width="150" alt="Data Axle USA"/>
    </div>
</template>

<script>
    export default {
        name: "preloader"
    };
</script>
